export const CLEAR_OFFER_STATUS_MANAGEMENT_STATE = 'CLEAR__OFFER_STATUS_MANAGEMENT_STATE';

export const GET_ALL_OFFER_STATUS = 'GET_ALL_OFFER_STATUS';
export const GET_ALL_OFFER_STATUS_SUCCESS = 'GET_ALL_OFFER_STATUS_SUCCESS';
export const GET_ALL_OFFER_STATUS_ERROR = 'GET_ALL_OFFER_STATUS_ERROR';

export const GET_OFFER_STATUS_BY_ID = 'GET_OFFER_STATUS_BY_ID';
export const GET_OFFER_STATUS_BY_ID_SUCCESS = 'GET_OFFER_STATUS_BY_ID_SUCCESS';
export const GET_OFFER_STATUS_BY_ID_ERROR = 'GET_OFFER_STATUS_BY_ID_ERROR';

export const CREATE_STATUS = 'CREATE_STATUS';
export const CREATE_STATUS_SUCCESS = 'CREATE_STATUS_SUCCESS';
export const CREATE_STATUS_ERROR = 'CREATE_STATUS_ERROR';

export const UPDATE_STATUS = 'UPDATE_STATUS';
export const UPDATE_STATUS_SUCCESS = 'UPDATE_STATUS_SUCCESS';
export const UPDATE_STATUS_ERROR = 'UPDATE_STATUS_ERROR';

export const DELETE_STATUS = 'DELETE_STATUS';
export const DELETE_STATUS_SUCCESS = 'DELETE_STATUS_SUCCESS';
export const DELETE_STATUS_ERROR = 'DELETE_STATUS_ERROR';
